import {
  IconCloudDataConnection,
  IconCpu,
  IconDatabase,
  IconArrowsSplit,
  IconServer2,
  IconListCheck,
  IconUsers,
  IconHeadset,
} from '@tabler/icons';

export const getPluralEntity = (entityType) => (context) => {
  if (context && context == 'entityHook') {
    if (entityType == 'integration') return 'integrations';
    if (entityType == 'flow') return 'flows';
    if (entityType == 'job') return 'jobs';
    if (entityType == 'schedule') return 'schedules';
    if (entityType == 'snapshot') return 'snapshots';
    if (entityType == 'data') return 'data';
    if (entityType == 'validation') return 'validations';
    if (entityType == 'api-service') return 'api-services';
    if (entityType == 'log') return 'logs';
  }
  if (entityType == 'snapshot') return 'snapshots';
  if (entityType == 'data') return 'data';
  if (entityType == 'integration') return 'connections';
  if (entityType == 'datastore') return 'datastores';
  if (entityType == 'blobstore') return 'blobstores';
  if (entityType == 'processor') return 'processors';
  if (entityType == 'feed') return 'feeds';
  if (entityType == 'validation') return 'validations';
  if (entityType == 'log') return 'logs';
};

export const getEntityType = (pluralType) => {
  if (pluralType == 'connections') return 'integration';
  if (pluralType == 'integrations') return 'integration';
  if (pluralType == 'datastores') return 'datastore';
  if (pluralType == 'blobstores') return 'blobstore';
  if (pluralType == 'processors') return 'processor';
  if (pluralType == 'feeds') return 'feed';
  // return 'pluralType not found';
};

export const getEntityIcon = (entityType) => {
  if (entityType == 'integrations' || entityType == 'connections')
    return IconCloudDataConnection;
  if (entityType == 'datastores') return IconDatabase;
  if (entityType == 'blobstores') return IconServer2;
  if (entityType == 'processors') return IconCpu;
  if (entityType == 'flows') return IconArrowsSplit;
  if (entityType == 'validations') return IconListCheck;
  if (entityType == 'users') return IconUsers;
  if (entityType == 'support') return IconHeadset;
  return IconCloudDataConnection;
};

export const getEntityCreateVerb = (entityType) => {
  if (
    entityType == 'processor' ||
    window.location.pathname.includes('configure')
  )
    return 'configure';
  return 'connect';
};
